<template>
	<div>
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div class="bg-white padding-xl">
			<div class="flex justify-between">
				<div class="text-lg flex" style="line-height:40px;">
					<div>
						<Avatar :src="'http://cjb.xahulian.com/'+ info.user.avatar " size="64" v-if="info.user.avatar" />
						<Avatar icon="ios-person" size="64" v-else />
					</div>
					<div class="padding-left padding-top-sm" style="line-height:25px;">
						<span class="text-bold text-black text-xl">{{info.user.nickname}}</span><br />
						<span class="text-bold text-blue">{{info.user.mobile}}</span>
					</div>
				</div>
			</div>
			<Divider />
			<Card :bordered="true" style="display:inline-block">
				<p slot="title">推广码：<span class="text-mauve text-xxl text-bold">{{info.tgm}}</span></p>
				<div style="text-align:center; padding:30px;">
					<img :src="'http://cjb.xahulian.com/'+info.ewm" />
				</div>
			</Card>
			<Divider orientation="left">推广会员</Divider>
			
			<Table border :data="tableData2" :columns="tableColumns2" size="large" :loading="loading" header="header" footer="footer">
				<template slot-scope="{ row }" slot="Avatar">
					<Avatar :src="'http://cjb.xahulian.com/'+ row.avatar " size="large" v-if="row.avatar" />
					<Avatar icon="ios-person" size="large" v-else />
				</template>
			
				<template slot="header">
					<div class="flex justify-between">
						<div span="12">
						</div>
						<div span="12">
							<div style="text-align: right;">
								<Page :total="pager.total" :page-size="pager.size" :current="pager.page" @on-change="pageChange"
								 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
							</div>
						</div>
					</div>
			
				</template>
				<template slot="footer">
					<div style="text-align: right;">
						<Page :total="pager.total" :page-size="pager.size" :current="pager.page" @on-change="pageChange"
						 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
					</div>
				</template>
			</Table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				uid: '',
				info: {
					user: {}
				},
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},

					{
						title: '头像',
						align: 'center',
						slot: 'Avatar',
						width: 150
					},
					{
						title: '昵称',
						align: 'center',
						key: 'nickname'
					},
					{
						title: '手机号',
						key: 'mobile',
						align: 'center'
					},
					{
						title: '推广码',
						key: 'tgm',
						align: 'center'
					},
					{
						title: '一级推广',
						key: 'yj',
						align: 'center'
					},
					{
						title: '二级推广',
						key: 'ej',
						align: 'center'
					},
					{
						title: '积分',
						key: 'score',
						align: 'center'
					},
					{
						title: '注册时间',
						key: 'addtime',
						align: 'center'
					}
				],
				tableData2: [],
				pager:{
					page:1,
					total:0,
					size:10
				}
			};
		},
		methods: {
			loadinfo() {
				let postData = {
					uid: this.uid
				};
				this.$http.post('/server/api/client/tg/view.php?a=init', this.$qs.stringify(postData)).then(
					res => {
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.info = res.data.data;
							this.loadinfos();
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.$Message.error('系统错误');
					}
				);
			},
			loadinfos() {
				this.loading = true;
				let postData = {
					page: this.pager.page,
					size: this.pager.size,
					uid: this.uid
				};
				this.$http.post('/server/api/client/tg/view.php?a=list', this.$qs.stringify(postData)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							this.pager.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.pager.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.pager.size = size;
				this.loadinfos();
			}
		},
		created() {
			//console.log(this.searchForm)
			this.uid = this.$route.params.id;
			this.loadinfo();
		}
	};
</script>

<style>
	img {
		display: block;
	}

	.imgbox {
		border: #ddd 1px solid;
		box-shadow: #aaa 0 0 8px;
	}

	.demo-spin-icon-load {
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
